import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesEyeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.333 9.333c2.333 0 4.473 2.5 4.667 3.334-.195.834-2.334 3.333-4.667 3.333s-4.471-2.5-4.666-3.333c.194-.833 2.333-3.334 4.666-3.334m0 2.084c-.937 0-1.25.625-1.25 1.25s.313 1.25 1.25 1.25 1.25-.625 1.25-1.25-.312-1.25-1.25-1.25"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1c6.563 0 7.5.875 7.5 7q0 .928-.035 1.701l-.085-.077c-.969-.83-2.403-1.691-4.047-1.691s-3.078.861-4.046 1.691a8.6 8.6 0 0 0-1.257 1.328c-.292.39-.609.895-.726 1.397l-.075.317.075.318c.117.502.434 1.007.726 1.396q.223.295.504.6C1.294 14.825.5 13.636.5 8c0-6.125.938-7 7.5-7M4 7.3v1.4h4V7.3zm0-2.666v1.4h8v-1.4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesEyeFilledSize16Glyph.displayName = 'CardLinesEyeFilledSize16Glyph';
